/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  CriticalElementSummaryDto,
  CriticalElementSummaryRequest
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType , BodyType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_REPORT_ADMIN**<br /><br />
 */
export const generateCriticalElementSummary = (
    userId: string,
    criticalElementSummaryRequest: BodyType<CriticalElementSummaryRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CriticalElementSummaryDto>(
      {url: `/api/${userId}/critical-element-summary`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: criticalElementSummaryRequest, signal
    },
      options);
    }



export const getGenerateCriticalElementSummaryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCriticalElementSummary>>, TError,{userId: string;data: BodyType<CriticalElementSummaryRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof generateCriticalElementSummary>>, TError,{userId: string;data: BodyType<CriticalElementSummaryRequest>}, TContext> => {

const mutationKey = ['generateCriticalElementSummary'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCriticalElementSummary>>, {userId: string;data: BodyType<CriticalElementSummaryRequest>}> = (props) => {
          const {userId,data} = props ?? {};

          return  generateCriticalElementSummary(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateCriticalElementSummaryMutationResult = NonNullable<Awaited<ReturnType<typeof generateCriticalElementSummary>>>
    export type GenerateCriticalElementSummaryMutationBody = BodyType<CriticalElementSummaryRequest>
    export type GenerateCriticalElementSummaryMutationError = ErrorType<unknown>

    export const useGenerateCriticalElementSummary = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCriticalElementSummary>>, TError,{userId: string;data: BodyType<CriticalElementSummaryRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateCriticalElementSummary>>,
        TError,
        {userId: string;data: BodyType<CriticalElementSummaryRequest>},
        TContext
      > => {
      return useMutation(getGenerateCriticalElementSummaryMutationOptions(options), queryClient);
    }
